import type { ActionableInsight } from "app/pages/activation/types/api";

export const buildInsightCopyPlainText = (insight: ActionableInsight): string => {
    const lines = [insight.title, "", insight.description, "", insight.suggestion];

    if (insight.competitors.length > 0) {
        lines.push("", insight.competitors.join(", "));
    }

    return lines.join("\n").replace(/\*\*(.+?)\*\*/g, "$1");
};
